<template>
    <div class="businessDetail app-inner">
        <div class="public-btn-small flex align-cen" style="padding-left:0;margin-bottom:16px">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
            <div class="p-tit-c">
 <div class="businessDetail-info flex align-cen">
    <div class="businessDetail-info-logo">
        <img :src="infoList.logo ? infoList.logo : require('../../../assets/images/blogo.png')" alt="">
    </div>
    <div class="businessDetail-info-con flex">
       <div class="list">
        企业ID：{{infoList.id}}
       </div>
         <div class="list">
        账号状态：{{infoList.accountState == 1 ? "开启" : '禁用'}}
       </div>
         <div class="list">
        默认账号：{{infoList.loginName}}
       </div>
         <div class="list">
        企业名称：{{infoList.name}}
       </div>
        <div class="list">
        企业类型：{{infoList.classifyName}}
       </div>
        <div class="list">
        企业电话：{{infoList.phone}}
       </div>
        <div class="list">
        企业地址：{{infoList.province}}{{infoList.city}}{{infoList.district}}{{infoList.address}}
       </div>
        <div class="list">
        默认账号姓名：{{infoList.userName}}
       </div>
       <div class="list">
        创建时间：{{infoList.createTime ? infoList.createTime : '暂无'}}
       </div>
        <div class="list flex align-cen" v-if="infoList.taxId">
        企业税号：
         <el-tooltip class="item" effect="dark" :content="infoList.taxId" placement="top-start" :visible-arrow="false">
        <div style="cursor: pointer;">{{infoList.taxId}}</div>
         </el-tooltip>
       </div>
        <div class="list flex align-cen" v-if="infoList.fullName">
        企业全称：
        <el-tooltip class="item" effect="dark" :content="infoList.fullName" placement="top-start" :visible-arrow="false">
        <div style="cursor: pointer;">
            {{infoList.fullName}}
        </div>
        </el-tooltip>
       </div>
    </div>
 </div>
 </div>
  <div class="businessDetail-data">
     <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  企业应用
            </div>
        </div>
             <el-table
            :data="infoList.appAuthorityVOList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="appName"
            label="开通应用"
           align="center"
             >
            </el-table-column>
             <el-table-column
            
            label="服务开始时间"
           align="center"
             >
              <template slot-scope="scope">
                <div>
                    {{scope.row.startTime || '无限制'}}
                </div>
             </template>
            </el-table-column>
             <el-table-column
            label="服务到期时间"
           align="center"
             >
             <template slot-scope="scope">
                <div>
                    {{scope.row.endTime || '无限制'}}
                </div>
             </template>
            </el-table-column>
             <el-table-column
            label="开通方式"
           align="center"
             >
             <template slot-scope="scope">
                <div>
                  {{scope.row.type == 2 ? '用户购买' : '人工授权'}}
                </div>
             </template>
            </el-table-column>
            </el-table>
  </div>
     <div class="businessDetail-data">
         <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  管理员信息
            </div>
        </div>
         <el-table
            :data="adminArr"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="userName"
            label="管理员姓名"
           align="center"
             >
            </el-table-column>
             <el-table-column
            prop="loginName"
            label="管理员账号"
           align="center"
             >
            </el-table-column>
             <el-table-column
            label="管理员微信"
           align="center"
             >
             <template slot-scope="scope">
                <div>
                    暂未绑定
                </div>
             </template>
            </el-table-column>
            </el-table>
     </div>
    <div class="businessDetail-data">
        <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  日志信息
            </div>
        </div>
         <!-- <div class="businessDetail-data-tit">禁用信息</div> -->
         <div class="businessDetail-data-table">
               <el-table
            :data="newArry"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="operateTime"
            label="时间"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="action"
            label="操作行为"
           align="center"
            >
            </el-table-column>
            <el-table-column
            prop="operator"
            label="操作人员"
           align="center"
            >
            </el-table-column>
             <el-table-column
            label="备注"
           align="center"
            >
            <template slot-scope="scope">
                <div>
                    {{ scope.row.remark || '暂无'}}
                </div>
            </template>
            </el-table-column>
        </el-table>
         </div>
                   <el-pagination
            class="jiange"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
    </div>
    </div>
</template>
<script>
import { businessDetail } from "@/api/index/index" //详情
export default {
    name:'businessDetail',
     data: () => {
    return {
        infoList:{},
        newArry:[],
      currentPage: 1, //初始页
      PageSize: 10, //每页的数据
      totalCount: 0,
      loading:false,
      pageSizes:[10,20,30,50,100],
      adminArr:[]
    }
     },
     created(){
        this.getDetail()
     },
     methods: {
            // 获取详情
        getDetail(){
            this.adminArr = []
              businessDetail({
                id:this.$route.query.id
              })
            .then(res => {
                this.infoList = res.data
                if(res.data.loginName){
                 this.adminArr = [
                    {
                        loginName:res.data.loginName,
                        userName:res.data.userName
                    }
                ]
                }
                this.getResultsData()
            })
            .catch(err => {
            })
        },
             //前端分页
            getResultsData() {
                // this指向改一下
                let that = this;
                let list =  this.infoList.accountOperationList; //后端回来表格的数据
                //渲染的数据newArry赋值
                this.newArry= list.filter(
                (item, index) =>
                    index < that.currentPage * that.PageSize &&
                    index >= that.PageSize * (that.currentPage - 1)
                ); //根据页数显示相应的内容
                this.totalCount = list.length;
            },
                 handleSizeChange(val) {
       this.PageSize = val
       this.getResultsData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.getResultsData()
    },
         reback(){
            if(this.$route.query.type == 1 ){
               this.$router.push('/businessList')
            }else if(this.$route.query.type == 3&&!this.$route.query.str){
                this.$router.push({name: "orderDetail", query:{ id:this.$route.query.redicetId}})
            }else{
                this.$router.push({name: "adminDetail", query:{ id:this.$route.query.redicetId,type:this.$route.query.type,str:this.$route.query.str}})
            }
        }
     }
}
</script>
<style lang="scss" scoped>
.businessDetail{
    height: inherit;
     .edit-header{
        padding: 0 20px;

    }
    .businessDetail-info{
        padding: 30px 20px 20px 20px; 
        .businessDetail-info-logo{
            width: 200px;
            border-right: 1px solid #ccc;
            img{
                width: 100px;
                height: 100px;
                border-radius: 100px;
                margin: 0 auto;
                display: block;
            }
        }
        .businessDetail-info-con{
            width: calc(100% - 200px);
            padding: 0 20px;
            flex-wrap: wrap;
            .list{
                width: 31%;
                padding-right: 2%;
                padding-bottom: 20px;
               div{
                width: 70%;
                 overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
               }
            }
        }
    }
    
    .businessDetail-data{
          .businessDetail-data-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
         .businessDetail-data-table{
            height: 200px;
            overflow: hidden;
            overflow-y: auto;
         }
                      .jiange {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    }
    }
</style>